import React, { ReactNode } from "react";
import {
  CssBaseline,
  ThemeProvider,
  createTheme,
  Box,
  Button,
  GlobalStyles,
} from "@mui/material";
// import './../../assets/styles/main.scss'; // Import the global SCSS file
import backgroundImage from "../../assets/images/aiLogoBg.png";

const theme = createTheme({

  typography: {
    fontFamily: "'HelveticaNeue-CondensedBold', 'Helvetica Neue' 'Arial', sans-serif", // Use Helvetica as the primary font
  },

  palette: {
    mode: "light",
    background: {
      //default: "red",
    },
    text: {
      primary: "#1D1D1D", // Custom text color (default text color)
    },
    primary: {
      main: "#02BEDB", // Custom primary color (used for focus and indicators)
    },
    secondary: {
      main: "#ff4081", // Custom secondary color for other elements
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          // This applies to all buttons
          "&.MuiButton-contained": {
            color: "#ffffff", // Custom text color for filled buttons
          },
          "&.MuiButton-containedSecondary": {
            backgroundColor: "#02BEDB", // Secondary filled button background color
          },
          "&:hover": {
            // Hover state for filled buttons
            "&.MuiButton-containedPrimary": {
              backgroundColor: "#35cbe2", // Hover background color
            },
            "&.MuiButton-containedSecondary": {
              //backgroundColor: "#35cbe2", // Hover background color
            },
          },
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          "&:hover": {
            backgroundColor: "#02BEDB", // Custom hover color for MenuItem
            color: "#000", // Custom text color when hovered
          },
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: "#fff", // Custom background color for the AppBar

          "&:hover": {
            //backgroundColor: '#000', // Custom hover color for MenuItem
            //color: "#ffffff", // Custom text color when hovered
          },
        },
      },
    },
    MuiListItem: {
      styleOverrides: {
        root: {
          "&:hover": {
            //backgroundColor: "#02BEDB", // Custom hover color for ListItemcolor: '#ffffff', // Custom text color on hover for ListItem
            color: "#02BEDB"
          },
        },
      },
    },
    // playground p tag make style break
    MuiTypography: {
      styleOverrides: {
        root: {
          '& p': {
            all: 'unset',  // Removes all default styling
          },
        },
      },
    },

  },
});

interface MyComponentProps {
  children: ReactNode; // Ensure you define children prop type
}

const ThemeCustomization: React.FC<MyComponentProps> = ({ children }) => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <GlobalStyles
        styles={{
          body: {
            backgroundImage: `url(${backgroundImage})`,
            backgroundSize: "auto",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "left bottom",
            backgroundAttachment: "fixed",
            minHeight: "100vh",
          },
        }}
      />
      {children}
    </ThemeProvider>
  );
};

export default ThemeCustomization;
